import { useEffect } from "react";

const SITE = "Paint With Tay";

export function useSeo({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Nanaimo Face Painter`;
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const desc = description || "Fun, professional, licensed & insured face painting for birthdays, markets, schools and special events throughout Nanaimo and surrounding communities.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE);
    setMeta("name", "twitter:card", "summary_large_image");
  }, [title, description, path]);
}

export function LocalBusinessLd() {
  const data = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Paint With Tay",
    description: "Professional face painting for birthdays, markets, schools, festivals and special events in Nanaimo and surrounding communities.",
    areaServed: "Nanaimo and surrounding communities, Vancouver Island, British Columbia",
    address: { "@type": "PostalAddress", addressLocality: "Nanaimo", addressRegion: "BC", addressCountry: "CA" },
    sameAs: ["https://www.instagram.com/paint.with.tay/"],
  };
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}
